// @flow
import { styled } from 'mz-ui-kit'

const SIZES = {
  normal: '18px',
  small: '12px',
  large: '38px',
  inherit: 'inherit',
}

export const Container = styled<{
  $size?: 'normal' | 'small' | 'large' | 'inherit',
}>('div', ({ $size }) => ({
  width: '1em',
  height: '1em',
  position: 'relative',
  display: 'inline-block',
  fontSize: $size ? SIZES[$size] : 'inherit',
}))

export const Bouncer = styled<{
  $delay?: boolean,
  $color?: string,
}>('div', ({ $delay, $color, $palette }) => ({
  width: '100%',
  height: '100%',
  borderRadius: '50%',
  opacity: 0.6,
  position: 'absolute',
  top: 0,
  left: 0,
  backgroundColor: `${
    $color === 'inherit' ? 'currentColor' : $palette($color)
  }`,
  animationDuration: '2s',
  animationTimingFunction: 'ease-in-out',
  animationIterationCount: 'infinite',
  animationDelay: $delay ? '-1.0s' : '0',
  animationName: {
    '0%, 100%': { transform: 'scale(0.0)' },
    '50%': { transform: 'scale(1.0)' },
  },
}))
